var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.075,
    height: 22.671,
    viewBox: "0 0 24.075 22.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_2818",
    "data-name": "\\u7EC4 2818",
    transform: "translate(-12593.399 -460.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_1172",
    "data-name": "\\u8DEF\\u5F84 1172",
    d: "M12617.475,476.473h-3.879a.725.725,0,0,0-.822.821q0,2.985,0,5.97v.294h-2.387v-9.9h1.445v-.275q0-1.269,0-2.538A2.819,2.819,0,0,1,12614.2,468a1.048,1.048,0,0,0,.113-.043c-.1-.022-.147-.037-.2-.047a2.818,2.818,0,0,1,.095-5.55,2.8,2.8,0,0,1,3.226,2.318,1.234,1.234,0,0,0,.042.133v.658a1.293,1.293,0,0,0-.042.132,2.821,2.821,0,0,1-2.17,2.294c-.074.017-.15.033-.247.053.034.029.039.037.046.038.037.009.075.016.113.024a2.645,2.645,0,0,1,1.8,1.2,7.636,7.636,0,0,1,.5,1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_1173",
    "data-name": "\\u8DEF\\u5F84 1173",
    d: "M12617.475,483.057a.887.887,0,0,1-.946.523c-.7-.023-1.4-.006-2.094-.006h-.239v-5.69h3.279Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_1174",
    "data-name": "\\u8DEF\\u5F84 1174",
    d: "M12595.907,467.947a2.826,2.826,0,1,1,3.086-3.531,2.741,2.741,0,0,1-.4,2.309,2.9,2.9,0,0,1-1.968,1.24,3.084,3.084,0,0,1,1.5.744,2.77,2.77,0,0,1,.914,2.065c.008.948,0,1.9,0,2.868h1.443v9.919h-2.384V483.3q0-3.009,0-6.017c0-.6-.261-.852-.861-.852h-3.84v-5.5a2.818,2.818,0,0,1,2.407-2.931A.61.61,0,0,0,12595.907,467.947Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_1175",
    "data-name": "\\u8DEF\\u5F84 1175",
    d: "M12608.959,472.241v11.23h-7.038v-11.23c-.388,0-.754,0-1.119,0-.117,0-.234.006-.352,0a.7.7,0,0,1,0-1.406h.07q4.913,0,9.827,0a.7.7,0,1,1,0,1.408C12609.9,472.246,12609.445,472.241,12608.959,472.241Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_1176",
    "data-name": "\\u8DEF\\u5F84 1176",
    d: "M12608.887,469.412h-6.9a3.426,3.426,0,0,1,1.076-1.93,3.745,3.745,0,0,1,1.988-.934,2.917,2.917,0,0,1-1.9-1.182,2.785,2.785,0,0,1-.479-2.162,2.825,2.825,0,1,1,3.16,3.347,3.61,3.61,0,0,1,2.522,1.543A3.13,3.13,0,0,1,12608.887,469.412Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_1177",
    "data-name": "\\u8DEF\\u5F84 1177",
    d: "M12596.674,483.573c-.878,0-1.74.007-2.6,0a.674.674,0,0,1-.669-.661c-.007-1.669,0-3.338,0-5.007,0-.014.011-.027.021-.052h3.248Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingRoom);
export default __webpack_public_path__ + "static/media/meeting-room.579f7b920e7b969d0be3628b924d7225.svg";
export { ForwardRef as ReactComponent };